import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filterPaysList',
    standalone: false
})
//permet de lister des pays en excluant un pays en particulier
export class FilterPaysListPipe implements PipeTransform {
	transform(items: any[], filter: any): any {
		if (!items || !filter) {
			return items;
		}
		// filter items array, items which match and return true will be
		// kept, false will be filtered out
		return items.filter(item => item.codeISO.indexOf(filter.codeISO) == -1);
	}
}
